import { render, staticRenderFns } from "./AddHostingClassification.vue?vue&type=template&id=4a9998ba&scoped=true"
import script from "./AddHostingClassification.vue?vue&type=script&lang=js"
export * from "./AddHostingClassification.vue?vue&type=script&lang=js"
import style0 from "./AddHostingClassification.vue?vue&type=style&index=0&id=4a9998ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9998ba",
  null
  
)

export default component.exports